<div class="preview-container">
  <div class="preview-header">
    <div class="header-content">
      <div>
        <h2>Message Preview</h2>
        <p class="preview-subtitle">See how your RCS message will appear</p>
      </div>
      <div class="os-selector">
        <button 
          class="os-btn" 
          [class.active]="selectedOS === 'ios'"
          (click)="switchOS('ios')"
          title="iPhone Preview">
          <span class="os-icon">📱</span>
          <span>iPhone</span>
        </button>
        <button 
          class="os-btn" 
          [class.active]="selectedOS === 'android'"
          (click)="switchOS('android')"
          title="Android Preview">
          <span class="os-icon">🤖</span>
          <span>Android</span>
        </button>
      </div>
    </div>
  </div>

  <div class="preview-content">
    <div class="phone-mockup" [class.ios]="selectedOS === 'ios'" [class.android]="selectedOS === 'android'">
      <div class="phone-header">
        <!-- iOS Dynamic Island / Notch -->
        <div class="phone-notch" *ngIf="selectedOS === 'ios'">
          <div class="dynamic-island"></div>
        </div>
        <!-- Android Camera Cutout -->
        <div class="android-cutout" *ngIf="selectedOS === 'android'">
          <div class="camera-hole"></div>
        </div>
        <div class="status-bar" [class.ios-status]="selectedOS === 'ios'" [class.android-status]="selectedOS === 'android'">
          <div class="status-left" *ngIf="selectedOS === 'ios'">
            <span class="time">9:41</span>
          </div>
          <div class="status-left" *ngIf="selectedOS === 'android'">
            <span class="time">9:41</span>
            <div class="status-icons">
              <span class="signal-icon">📶</span>
              <span class="wifi-icon">📶</span>
              <span class="battery-icon">🔋</span>
            </div>
          </div>
          <div class="status-right" *ngIf="selectedOS === 'ios'">
            <div class="signal-bars">
              <span></span><span></span><span></span><span></span>
            </div>
            <div class="wifi-icon-ios">📶</div>
            <div class="battery-ios">
              <div class="battery-level"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="phone-screen" [class.ios-screen]="selectedOS === 'ios'" [class.android-screen]="selectedOS === 'android'">
        <!-- SMS Message Preview -->
        <div *ngIf="message && message.type === MessageType.SMS" class="sms-preview">
          <div class="message-bubble" [class.ios-bubble]="selectedOS === 'ios'" [class.android-bubble]="selectedOS === 'android'">
            <p>{{ message.smsText || 'Enter your SMS message...' }}</p>
          </div>
        </div>
        
        <!-- iOS RCS Handling - iOS 18+ supports RCS with green bubbles -->
        <div *ngIf="selectedOS === 'ios' && message && message.type !== MessageType.SMS" class="ios-rcs-container">
          <div class="message-bubble ios-rcs-bubble">
            <!-- iOS RCS Text Messages - Green bubbles (iOS 18+) -->
            <div *ngIf="message.type === MessageType.TEXT" class="text-preview">
              <p>{{ message.text || 'Enter your message text...' }}</p>
              <!-- iOS RCS supports suggestions as buttons -->
              <div class="suggestions ios-rcs-suggestions" *ngIf="message.suggestions && message.suggestions.length > 0">
                <button 
                  class="suggestion-btn ios-rcs-btn" 
                  *ngFor="let suggestion of message.suggestions"
                  (click)="handleSuggestionClick(suggestion, $event)"
                  [title]="getSuggestionTooltip(suggestion)">
                  {{ suggestion.displayText }}
                </button>
              </div>
            </div>
            
            <!-- iOS RCS Rich Cards - Supported in iOS 18+ (green bubble style) -->
            <div *ngIf="message.type === MessageType.STANDALONE && message.richCard" class="rich-card-preview ios-rcs-rich-card">
              <div class="rich-card-layout" [class.vertical]="message.richCard.orientation === 'VERTICAL'" [class.horizontal]="message.richCard.orientation === 'HORIZONTAL'">
                <!-- Thumbnail (if present) -->
                <div class="card-thumbnail" *ngIf="message.richCard.thumbnail && message.richCard.thumbnail.url" 
                     [class.left]="message.richCard.thumbnailAlignment === 'LEFT'"
                     [class.right]="message.richCard.thumbnailAlignment === 'RIGHT'">
                  <img [src]="message.richCard.thumbnail!.url" alt="Card thumbnail" (error)="handleImageError($event)">
                </div>
                <!-- Main Media -->
                <div class="card-media" *ngIf="message.richCard.media && message.richCard.media.url">
                  <img [src]="message.richCard.media!.url" alt="Card media" (error)="handleImageError($event)">
                </div>
              </div>
              <div class="card-content">
                <h3>{{ message.richCard.title || 'Card Title' }}</h3>
                <p>{{ message.richCard.description || 'Card description...' }}</p>
                <div class="suggestions ios-rcs-suggestions" *ngIf="message.richCard.suggestions && message.richCard.suggestions.length > 0">
                  <button 
                    class="suggestion-btn ios-rcs-btn" 
                    *ngFor="let suggestion of message.richCard.suggestions"
                    (click)="handleSuggestionClick(suggestion, $event)"
                    [title]="getSuggestionTooltip(suggestion)">
                    {{ suggestion.displayText }}
                  </button>
                </div>
              </div>
            </div>
            
            <!-- iOS RCS Carousel Support - iOS 18+ (green bubble style) -->
            <div *ngIf="message.type === MessageType.CAROUSEL && message.carousel" class="carousel-preview ios-rcs-carousel">
              <div class="carousel-container">
                <div 
                  class="carousel-card ios-card" 
                  *ngFor="let card of message.carousel.cards; let i = index"
                  [style.width]="message.carousel.width === 'SMALL' ? '200px' : '280px'">
                  <!-- Thumbnail (if present) -->
                  <div class="card-thumbnail" *ngIf="card.thumbnail && card.thumbnail.url">
                    <img [src]="card.thumbnail!.url" alt="Card thumbnail" (error)="handleImageError($event)">
                  </div>
                  <!-- Main Media -->
                  <div class="card-media" *ngIf="card.media && card.media.url">
                    <img [src]="card.media!.url" alt="Card media" (error)="handleImageError($event)">
                  </div>
                  <div class="card-content">
                    <h4>{{ card.title || 'Card ' + (i + 1) }}</h4>
                    <p>{{ card.description || 'Description...' }}</p>
                    <div class="card-suggestions" *ngIf="card.suggestions && card.suggestions.length > 0">
                      <button 
                        class="suggestion-btn-small ios-btn" 
                        *ngFor="let suggestion of card.suggestions"
                        (click)="handleSuggestionClick(suggestion, $event)"
                        [title]="getSuggestionTooltip(suggestion)">
                        {{ suggestion.displayText }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-indicators">
                <span 
                  *ngFor="let card of message.carousel.cards; let i = index"
                  class="indicator"
                  [class.active]="i === 0">
                </span>
              </div>
              <div class="carousel-suggestions ios-rcs-suggestions" *ngIf="message.suggestions && message.suggestions.length > 0">
                <button 
                  class="suggestion-btn ios-rcs-btn" 
                  *ngFor="let suggestion of message.suggestions"
                  (click)="handleSuggestionClick(suggestion, $event)"
                  [title]="getSuggestionTooltip(suggestion)">
                  {{ suggestion.displayText }}
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Android RCS Handling - Full native support -->
        <div *ngIf="selectedOS === 'android' && message && message.type !== MessageType.SMS" class="android-rcs-container">
          <div class="message-bubble android-bubble">
            <!-- Android: Full RCS Text Message Support -->
            <div *ngIf="message.type === MessageType.TEXT" class="text-preview">
              <p>{{ message.text || 'Enter your message text...' }}</p>
              <div class="suggestions android-suggestions" *ngIf="message.suggestions && message.suggestions.length > 0">
                <button 
                  class="suggestion-btn android-btn" 
                  *ngFor="let suggestion of message.suggestions"
                  (click)="handleSuggestionClick(suggestion, $event)"
                  [title]="getSuggestionTooltip(suggestion)">
                  {{ suggestion.displayText }}
                </button>
              </div>
            </div>

            <!-- Android: Full RCS Rich Card Support -->
            <div *ngIf="message.type === MessageType.STANDALONE && message.richCard" class="rich-card-preview android-rich-card">
              <div class="rich-card-layout" [class.vertical]="message.richCard.orientation === 'VERTICAL'" [class.horizontal]="message.richCard.orientation === 'HORIZONTAL'">
                <!-- Thumbnail (if present) -->
                <div class="card-thumbnail" *ngIf="message.richCard.thumbnail && message.richCard.thumbnail.url" 
                     [class.left]="message.richCard.thumbnailAlignment === 'LEFT'"
                     [class.right]="message.richCard.thumbnailAlignment === 'RIGHT'">
                  <img [src]="message.richCard.thumbnail!.url" alt="Card thumbnail" (error)="handleImageError($event)">
                </div>
                <!-- Main Media -->
                <div class="card-media" *ngIf="message.richCard.media && message.richCard.media.url">
                  <img [src]="message.richCard.media!.url" alt="Card media" (error)="handleImageError($event)">
                </div>
              </div>
              <div class="card-content">
                <h3>{{ message.richCard.title || 'Card Title' }}</h3>
                <p>{{ message.richCard.description || 'Card description...' }}</p>
                <div class="suggestions android-suggestions" *ngIf="message.richCard.suggestions && message.richCard.suggestions.length > 0">
                  <button 
                    class="suggestion-btn android-btn" 
                    *ngFor="let suggestion of message.richCard.suggestions"
                    (click)="handleSuggestionClick(suggestion, $event)"
                    [title]="getSuggestionTooltip(suggestion)">
                    {{ suggestion.displayText }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Android: Full RCS Carousel Support -->
            <div *ngIf="message.type === MessageType.CAROUSEL && message.carousel" class="carousel-preview android-carousel">
              <div class="carousel-container">
                <div 
                  class="carousel-card android-card" 
                  *ngFor="let card of message.carousel.cards; let i = index"
                  [style.width]="message.carousel.width === 'SMALL' ? '200px' : '240px'"
                  [style.min-width]="message.carousel.width === 'SMALL' ? '200px' : '240px'"
                  [style.max-width]="message.carousel.width === 'SMALL' ? '200px' : '240px'">
                  <!-- Thumbnail (if present) -->
                  <div class="card-thumbnail" *ngIf="card.thumbnail && card.thumbnail.url">
                    <img [src]="card.thumbnail!.url" alt="Card thumbnail" (error)="handleImageError($event)">
                  </div>
                  <!-- Main Media -->
                  <div class="card-media" *ngIf="card.media && card.media.url">
                    <img [src]="card.media!.url" alt="Card media" (error)="handleImageError($event)">
                  </div>
                  <div class="card-content">
                    <h4>{{ card.title || 'Card ' + (i + 1) }}</h4>
                    <p>{{ card.description || 'Description...' }}</p>
                    <div class="card-suggestions" *ngIf="card.suggestions && card.suggestions.length > 0">
                      <button 
                        class="suggestion-btn-small android-btn" 
                        *ngFor="let suggestion of card.suggestions"
                        (click)="handleSuggestionClick(suggestion, $event)"
                        [title]="getSuggestionTooltip(suggestion)">
                        {{ suggestion.displayText }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-indicators">
                <span 
                  *ngFor="let card of message.carousel.cards; let i = index"
                  class="indicator"
                  [class.active]="i === 0">
                </span>
              </div>
              <div class="carousel-suggestions android-suggestions" *ngIf="message.suggestions && message.suggestions.length > 0">
                <button 
                  class="suggestion-btn android-btn" 
                  *ngFor="let suggestion of message.suggestions"
                  (click)="handleSuggestionClick(suggestion, $event)"
                  [title]="getSuggestionTooltip(suggestion)">
                  {{ suggestion.displayText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
